import { CALL_API } from 'redux-api-middleware';

export const REPORT_REQUEST_GET = Symbol('REPORT_REQUEST_GET');
export const REPORT_SUCCESS_GET = Symbol('REPORT_SUCCESS_GET');
export const REPORT_FAILURE_GET = Symbol('REPORT_FAILURE_GET');

export function getFinishQuestionnaireUrl() {
	return {
		[CALL_API]: {
			endpoint: `${process.env.API_URI}/api/getFinishQuestionnaireUrl`,
			method: 'GET',
			headers: {
				'Accept': 'application/json'
			},
			types: [
				REPORT_REQUEST_GET,
				REPORT_SUCCESS_GET,
				REPORT_FAILURE_GET
			]
		}
	};
}
